import { _ } from "../polyglot/polyglot.js";

/**
 * Translates a server notification message.
 * This is to allow the tools to detect the strings that are being translated.
 */
export default function translateServerNotification(message) {
	switch (message) {
		case "OAuthAccessDenied": {
			return _("The request was either canceled or rejected.");
		}
		case "OAuthSessionExpired": {
			return _("The session has expired, please try again.");
		}
		case "FortnoxLicenseMissing": {
			return _(
				"The requested Fortnox account does not have a license to use the API.",
			);
		}
		case "FortnoxNoFiscalYearFound": {
			return _("The company has no fiscal year.");
		}
		case "FortnoxNoPermissionToImportData": {
			return _("You do not have permission to import company data.");
		}
		default: {
			return message;
		}
	}
}
